﻿import { getTranslations } from "../../translations";
import { Popup, PopupPosition } from "../../utilities/popup";
import { sendDataLayer } from "../ecommerce/ecommerce";
import { addArticleLocationToStash } from "../shoppingcart/shoppingcart";

declare const cartMergeTemplate: HTMLElement;
declare const currentCartArticles: any;
declare const savedCartArticles: any;

document.addEventListener("DOMContentLoaded", function ()
{
    if (typeof cartMergeTemplate !== "undefined" && cartMergeTemplate && currentCartArticles && savedCartArticles)
    {
        sendDataLayer({
            'event': 'Klantenmededelingen',
            'category': 'Klantenmededelingen',
            'action': document.location.href,
            'label': 'winkelwagens samenvoegen',
            'productIDs': `${currentCartArticles} | ${savedCartArticles}`
        });
    }
});

window.addEventListener("load", function ()
{
    if (typeof cartMergeTemplate !== "undefined" && cartMergeTemplate)
        initCartMergePopup();
});

function initCartMergePopup()
{
    const cartMergePopup = new Popup({
        id: "cart-merge",
        content: cartMergeTemplate,
        closeButton: true,
        desktopPosition: PopupPosition.Center,
        title: getTranslations().txtUtilShoppingCart,
    });

    cartMergePopup.show();

    $(cartMergePopup.getContent()).find(".btn").on("click", function ()
    {
        var option = $(this).text().trim().toLowerCase();

        sendDataLayer({
            'event': 'Klantenmededelingen',
            'category': 'Klantenmededelingen',
            'action': document.location.href,
            'label': option
        });
    });

    $('#previouscart').on('click', function (event)
    {
        var currentItems = $('#currentcartitems .product-info');
        var previousItems = $('#previouscartitems .product-info');

        $(currentItems).each(function (index)
        {
            var articleNumber = $(this).data("articlenumber");
            $.stash.remove(articleNumber);
        });

        $(previousItems).each(function (index)
        {
            var articleNumber = $(this).data("articlenumber");
            addArticleLocationToStash(articleNumber, 'winkelwagen samenvoegen');
        });
    });

    $('#mergecarts').on('click', function (event)
    {
        var previousItems = $('#previouscartitems .product-info');

        $(previousItems).each(function (index)
        {
            var articleNumber = $(this).data("articlenumber");
            addArticleLocationToStash(articleNumber, 'winkelwagen samenvoegen');
        });
    });
}